import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { stroke: "#BDC0D0", fill: "#BDC0D0", strokeWidth: 0, viewBox: "0 0 20 20", height: "3em", width: "2em", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(SvgChevronRight);
export default ForwardRef;
